/* eslint-disable no-underscore-dangle */
/* eslint-disable react/no-array-index-key */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { FC } from 'react';
import Link from 'next/link';
import SocialLink from 'components/SocialLinks';
import SvgLib from 'components/SvgLib';
import LinkGraphQL from 'components/LinkGraphQL';
import { Accordion, AccordionDetails, AccordionSummary } from '@mui/material';
import {
  CLinkPropsGraphQL,
  FooterGraphQL,
} from '../../models/Contentful/types/siteTemplateGraphQL';

import ImageComponent from '../Image';
import SectionWrapper from '../SectionWrapper';
import styles from './footer.module.sass';
import { useIsMobileViewport } from '../../hooks/useIsMobileViewport';

const AppFooter: FC<FooterGraphQL> = props => {
  const { isMobile } = useIsMobileViewport();
  const { logo, navigationMenus, socialLinksCollection, utilityLinksCollection } = props;

  if (isMobile)
    return (
      <div>
        <div
          className={`is-flex is-flex-direction-column is-align-items-center is-justify-content-center py-6 ${styles.appFooter}`}
        >
          <div className={styles.appFooterMobileSocial}>
            <Link href="/">
              <ImageComponent
                image={logo?.url}
                width="60px"
                height="60px"
                classes={`mb-4 ${styles.imageContainer}`}
              />
            </Link>
            <div className={styles.appFooterSocialLinks}>
              {socialLinksCollection?.items?.map((nav, index) => (
                <SocialLink
                  item={nav}
                  key={nav.sys?.id ?? index}
                  classes={styles.appFooterSocialIcon}
                >
                  {nav.icon && <SvgLib icon={nav.icon} />}
                </SocialLink>
              ))}
            </div>
          </div>
          {navigationMenus?.items?.map((nav, index) => (
            <Accordion
              key={nav.sys?.id ?? index}
              className={styles.appFooterAccordionItem}
              elevation={0}
            >
              <AccordionSummary
                expandIcon={<SvgLib icon="arrow-down" classes={styles.appFooterAccordionArrow} />}
                className={styles.appFooterAccordionTitle}
              >
                {nav.navMenuTitle}
              </AccordionSummary>
              <AccordionDetails className={styles.appFooterAccordionContent}>
                {nav.navigationLinks?.items?.map(item => (
                  <div key={item.sys?.id} className={styles.appFooterAccordionLink}>
                    <LinkGraphQL {...item} showPrivateLinks />
                    <SvgLib icon="arrow-down" classes={styles.appFooterAccordionArrowLink} />
                  </div>
                ))}
              </AccordionDetails>
            </Accordion>
          ))}
        </div>

        <div className={styles.appFooterSocialContainerMobile}>
          <p>
            {utilityLinksCollection?.items.map((nav: CLinkPropsGraphQL, index: number) => (
              <>
                <LinkGraphQL key={nav.sys?.id} {...nav} />
                {index < (utilityLinksCollection?.items.length ?? 0) - 1 && ' | '}
              </>
            ))}
          </p>
          <p>{`COPYRIGHT © ${new Date().getFullYear()} NAF ALL RIGHTS RESERVED.`}</p>
        </div>
      </div>
    );

  return (
    <>
      <SectionWrapper classes={styles.appFooter}>
        <div className="columns is-multiline">
          <div className={`column is-3 ${styles.imageContainer}`}>
            <Link href="/">
              <ImageComponent image={logo?.url} width="142px" height="148px" />
            </Link>
          </div>
          {navigationMenus?.items?.map((nav, index: number) => (
            <div key={nav.sys?.id ?? index} className={`${styles.appFooterMenuLinks} column is-3`}>
              <h4 className={styles.appFooterMenuTitle}>{nav.navMenuTitle}</h4>
              {nav.navigationLinks?.items?.map(item => (
                <div key={item.sys?.id}>
                  <LinkGraphQL {...item} showPrivateLinks classes={``} />
                </div>
              ))}
            </div>
          ))}
        </div>
      </SectionWrapper>
      <SectionWrapper classes={styles.appFooterSocial}>
        <div className={styles.appFooterSocialContainer}>
          <div className={styles.appFooterSocialLinks}>
            {socialLinksCollection?.items?.map((nav, index) => (
              <SocialLink
                item={nav}
                key={nav.sys?.id ?? index}
                classes={styles.appFooterSocialIcon}
              >
                {nav.icon && <SvgLib icon={nav.icon} />}
              </SocialLink>
            ))}
          </div>
          <div className={styles.appFooterSocialLegal}>
            <p>
              {utilityLinksCollection?.items.map((nav: CLinkPropsGraphQL, index: number) => (
                <>
                  <LinkGraphQL key={nav.sys?.id} {...nav} />
                  {index < (utilityLinksCollection?.items.length ?? 0) - 1 && ' | '}
                </>
              ))}
            </p>
            <p>{`COPYRIGHT © ${new Date().getFullYear()} NAF ALL RIGHTS RESERVED.`}</p>
          </div>
        </div>
      </SectionWrapper>
    </>
  );
};

export default AppFooter;
